import React, { FC } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  HStack,
  Box,
  Divider,
} from "@chakra-ui/react";
import Overview from "./Overview";
import Feature from "./Feature";
import PartsAndAccessory from "./PartsAndAccessory";
import Specification from "./Specification";
import Resource from "./Resource";
import Faq from "./Faq";
import useProductDetailPageAttrQuery from "../hooks/useProductDetailPageAttrQuery";
import { InfoTabHero } from "../styles";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";

const InfoTab: FC = () => {
  const { data: result } = useProductDetailPageAttrQuery();
  const {
    overview,
    features,
    parts_and_accessories,
    specifications,
    resources,
    faq,
  } = result!.data.attributes;

  const resourceData = resources.data;

  const infoTabListArr = [
    {
      tabName: "Overview",
      data: overview,
      tabPanel: <Overview />,
    },
    {
      tabName: "Features",
      data: features,
      tabPanel: <Feature />,
    },

    {
      tabName: "Parts & Accessories",
      data: parts_and_accessories,
      tabPanel: <PartsAndAccessory />,
    },
    {
      tabName: "Specifications",
      data: specifications,
      tabPanel: <Specification />,
    },
    {
      tabName: "Resources",
      data: resourceData,
      tabPanel: <Resource />,
    },
    {
      tabName: "FAQs",
      data: faq,
      tabPanel: <Faq />,
    },
  ];

  const infoTabList = infoTabListArr.filter((item) => {
    return (
      item.data && (Array.isArray(item.data) ? item.data.length > 0 : true)
    );
  });

  return (
    <ResponsiveContainer>
      <InfoTabHero>
        <Tabs colorScheme="blue" isLazy variant="unstyled" px={0}>
          <TabList
            overflowX={"auto"}
            css={{
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                width: "0",
                height: "0",
              },
            }}
          >
            <Box>
              <HStack>
                {infoTabList.map((item, index) => (
                  <Tab
                    key={index}
                    pb={5}
                    pt={10}
                    px={{ base: 4, md: 10 }}
                    css={{ whiteSpace: "nowrap" }}
                    position={"relative"}
                    borderWidth={0}
                    borderColor={"transparent"}
                  >
                    <Box>{item.tabName}</Box>
                    <Box
                      h={"4px"}
                      bg={"blue500"}
                      position={"absolute"}
                      bottom={0}
                      zIndex={1}
                      width={"100%"}
                      borderRadius={"4px"}
                      display={"none"}
                      aria-label="indicator"
                    />
                  </Tab>
                ))}
              </HStack>
            </Box>
          </TabList>
          <Divider />
          <Box>
            <TabPanels my={7}>
              {infoTabList.map((item, index) => (
                <TabPanel px={0} key={index}>
                  {item.tabPanel}
                </TabPanel>
              ))}
            </TabPanels>
          </Box>
        </Tabs>
      </InfoTabHero>
    </ResponsiveContainer>
  );
};

export default InfoTab;
